<script setup lang="ts">
import { isMobile } from '@basitcodeenv/vue3-device-detect';
import ModalHeader from '@/components/Header/ModalHeader.vue';
import { ref, watch, computed } from 'vue';
const props = withDefaults(
    defineProps<{
        visible: boolean;
        severity?: 'light' | 'dark';
        isBorder?: boolean;
        noPadding?: boolean;
        maxWidth?: string;
        isBackButton?: boolean;
        dismissableMask?: boolean;
        isCloseButton?: boolean;
        noHeader?: boolean;
        isCashReg?: boolean;
        contentBgColor?: string;
    }>(),
    {
        visible: false,
        severity: 'light',
        isBorder: false,
        maxWidth: '50rem',
        isBackButton: false,
        dismissableMask: true,
        isCloseButton: true,
        noHeader: false,
        isCashReg: false,
        contentBgColor: 'gray-light'
    }
);
const visible = ref(props.visible);
const emit = defineEmits(['close', 'back']);
watch(
    () => props.visible,
    (value) => {
        visible.value = value;
    }
);
watch(visible, (value) => {
    if (!value) {
        emit('close');
    }
});
const dialogClassesBySeverity = computed(() => {
    const baseClass = isMobile ? '_no-rounded rounded-b-none' : '_no-t-rounded rounded-b-[10px]';
    const paddingClass = props.noPadding ? '!p-0' : props.isCashReg && isMobile ? '!p-0' : '!pt-[10px]';
    switch (props.severity) {
        case 'light':
            return `light-scroll ${baseClass} ${paddingClass}`;
        case 'dark':
            return `dark-scroll ${baseClass} ${paddingClass}`;
        default:
            return `dark-scroll ${baseClass} ${paddingClass}`; // default fallback
    }
});
function backCallback() {
    emit('back');
}
const cashRegInnerClasses = computed(() => {
    const onlyMobileClass = props.isCashReg && isMobile ? 'max-h-screen' : '';
    const onlyDesktopClass = props.isCashReg && !isMobile ? 'max-h-[calc(100vh-100px)]' : '';
    const baseClass = props.isCashReg ? 'overflow-y-auto overflow-x-hidden' : '';
    return `${onlyMobileClass} ${onlyDesktopClass} ${baseClass}`;
});
</script>
<template>
    <Dialog
        v-model:visible="visible"
        :class="{
            'p-dialog-maximized !max-w-full': isMobile,
            'is-mobile': isMobile
        }"
        modal
        :dismissable-mask="dismissableMask"
        :closable="false"
        :style="{ 'max-width': maxWidth }"
        pt:root:class="!border-0 !rounded-lg !bg-transparent w-full"
        :pt:mask:class="dismissableMask ? 'backdrop-blur-sm' : ''"
    >
        <template #container="{ closeCallback }">
            <ModalHeader v-if="!noHeader" @close="closeCallback" @back="backCallback" :isBorder="props.isBorder" :isCloseButton="props.isCloseButton" :isBackButton="props.isBackButton">
                <template #title>
                    <slot name="title" />
                </template>
            </ModalHeader>
            <div class="p-dialog-content mt-[50px]" :class="[dialogClassesBySeverity]" :style="{ 'background-color': `var(--${props.contentBgColor})` }">
                <div class="p-dialog-content-inner" :class="cashRegInnerClasses"><slot name="content" /></div>
                <div class="p-dialog-content-actions"><slot name="actions" /></div>
            </div>
        </template>
    </Dialog>
</template>
